import { IInitialState } from "./types";
export const initialState: IInitialState = {
  users: {
    params: {
      page: 1,
      pageSize: 10,
      status: null
    },
    response: {
      data: null,
      loading: false,
      error: null,
    },
  },
  disabledUsers: {
    params: {
      page: 1,
      pageSize: 10,
      status: null,
    },
    response: {
      data: null,
      loading: false,
      error: null,
    },
  },
  usersLookup: {
    params: {
      page: 1,
      pageSize: 10,
      hasMore: true,
    },
    response: {
      data: null,
      loading: false,
      error: null,
    },
  },
  meUsers: {
    params: {},
    response: {
      data: null,
      loading: false,
      error: null,
    }
  },
  usersWithoutPromocodes: {
    params: {
      page: 1,
      pageSize: 10,
      orderBy: null,
      voucherId: null,
    },
    response: {
      data: null,
      loading: false,
      error: null,
    },
  },
  userByUserId: {
    params: {
      userId: null
    },
    response: {
      data: null,
      loading: false,
      error: null,
    },
  },
  usersByAdmins: {
    params: {
      page: 1,
      pageSize: 10,
      status: null
    },
    response: {
      data: null,
      loading: false,
      error: null,
    },
  },
  postUsers: {
    data: null,
    loading: false,
    error: null,
  },
  putUsers: {
    data: null,
    loading: false,
    error: null,
  },
  putMeUsers: {
    data: null,
    loading: false,
    error: null,
  },
  deleteUsers: {
    data: null,
    loading: false,
    error: null,
  },
  putUsersLang: {
    data: null,
    loading: false,
    error: null,
  }
};